<nb-card *ngIf="!missionSelected" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="large">
  <nb-card-header>
    <nb-checkbox [checked]="selectAll" (checkedChange)="toggleAll($event)">Import open missions :</nb-checkbox>
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item *ngFor="let data of dataMissionToImport; let i = index">
        <div >
          <nb-checkbox [checked]="data.checked" (checkedChange)="toggleMission($event, data)">
            <span [ngClass]="{'mission_ependence': data.isDependentOn}">{{ data.mission.name | txtTranslate }}</span>
          </nb-checkbox>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
  <nb-card-footer>
      <button class="cancel mr-3" nbButton status="danger" (click)="cancel()">Cancel</button>
      <button nbButton status="success" (click)="importMissionSelected()">Import</button>
  </nb-card-footer>
</nb-card>
<nb-card *ngIf="missionSelected" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="large">
  <nb-card-body>
    <nb-stepper #stepper [(selectedIndex)]="stepperIndex" orientation="horizontal">
      <ng-template ngFor let-openMission="$implicit" [ngForOf]="selectedMissions" let-i="index">
        <nb-step>
          <div class="">
            <p>Choose where to place the mission <strong>{{openMission.name[languageService.currentLang]}}</strong></p>    
            <br>
            <div class="items-center inline-flex"> 
              <nb-radio-group [(ngModel)]="selectedOption">
                <nb-radio value="0">Above</nb-radio>
                <nb-radio value="1">Below</nb-radio>
              </nb-radio-group>
              <nb-select placeholder="Select mission" style="width: 20rem;" class="ml-2" [(selected)]="selectedGameMission">
                <nb-option *ngFor="let mission of game.missions" [value]="mission">
                  {{ mission.name | txtTranslate }}
                </nb-option>
              </nb-select>
            </div>
          </div>
          <div class="absolute bottom-4">
            <button nbButton status="success" (click)="import(openMission, i)" class="ml-2" [disabled]="!selectedGameMission || !selectedOption">Import</button>
          </div>
        </nb-step>
      </ng-template>
    </nb-stepper>
  </nb-card-body>
</nb-card>